import { render, staticRenderFns } from "./evaluaciones_coordinadores.vue?vue&type=template&id=3b6c6428"
import script from "./evaluaciones_coordinadores.vue?vue&type=script&lang=js"
export * from "./evaluaciones_coordinadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports